import { render, staticRenderFns } from "./overviewCompany.vue?vue&type=template&id=1bd6eb30&scoped=true"
import script from "./overviewCompany.vue?vue&type=script&lang=js"
export * from "./overviewCompany.vue?vue&type=script&lang=js"
import style0 from "./overviewCompany.vue?vue&type=style&index=0&id=1bd6eb30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd6eb30",
  null
  
)

export default component.exports